import { Head } from '@inertiajs/react'
import type { ReactNode } from 'react'
import Layout from '@/components/Layout'

function Hello({ name }: { name: string }) {
  return (
    <>
      <Head title="Hello" />
      <div className="min-h-screen bg-background flex items-center justify-center font-sans">
        <div className="text-center p-10 rounded-2xl bg-card shadow-xl max-w-xl">
          <h1 className="text-4xl font-headline font-bold text-primary">Hello, {name}!</h1>
          <p className="text-foreground mt-3">Rails 8 + Inertia 2 + React 19 + Vite + Tailwind 4 — Phase 0 scaffold.</p>
          <p className="text-sm text-muted-foreground mt-6">Next: Phase 1 — repo + Railway preview.</p>

          {/* Design token smoke-test swatch — tested by Story 3.1 system test */}
          <div
            data-testid="colorado-blue-swatch"
            className="bg-colorado-blue w-8 h-8 rounded mt-6 mx-auto"
            aria-label="Colorado Blue color swatch"
          />
        </div>
      </div>
    </>
  )
}

Hello.layout = (page: ReactNode) => <Layout>{page}</Layout>

export default Hello
